// diag/netError.js — EL MICROSCOPIO de fallas de red (F6.7b, pasada final 2).
//
// El smoke del 28-jul dejó MEDIDA una ventana variable post-NET.UP (de 0.4 s a
// ~2 min) en la que todo fallo llega "con forma de red" — pero el registro no
// decía QUÉ forma: ¿DNS que no resuelve? ¿conexión rechazada? ¿techo de espera
// agotado? ¿petición cancelada? La hipótesis principal (caché negativo de
// DNS/conexión de iOS sembrado por los intentos hechos sin señal) no se puede
// confirmar ni descartar sin ese dato. Esto lo captura: en CADA punto donde hoy
// se clasifica un fallo como forma-de-red se apunta NET.ERR {op, code, msg} al
// visor. op ∈ {documents, sync-state, bundle, login, signup, refresh}.
//
// SOLO REGISTRO — cero cambios de comportamiento: logNetError jamás lanza, no
// espera nada, y en web es no-op total (readyChainLog gatea por IS_APP_BUILD).
//
// `code` es el dato que el smoke no tuvo: el e.code de axios (ERR_NETWORK,
// ECONNABORTED, ERR_CANCELED, ETIMEDOUT…) o el name del error nativo. Con él,
// la ventana post-NET.UP deja de ser "falló" y pasa a ser "falló ASÍ".

import { log } from './readyChainLog';

/** El detalle {code, msg} de un error, con el TIPO de fallo visible. */
export function netErrorDetail(err) {
  let code = 'unknown';
  let msg = '';
  try {
    if (err && err.code) code = String(err.code);
    else if (err && err.name && err.name !== 'Error') code = String(err.name);
    msg = String((err && err.message) || err || '').slice(0, 80);
  } catch (e) { /* un error ilegible no rompe el microscopio */ }
  return { code, msg };
}

/**
 * logNetError(op, err) — apunta NET.ERR {op, code, msg} al visor.
 * @param {string} op  'documents'|'sync-state'|'bundle'|'login'|'signup'|'refresh'
 */
export function logNetError(op, err) {
  try {
    const { code, msg } = netErrorDetail(err);
    log('NET.ERR', { op, code, msg });
  } catch (e) { /* fire-and-forget: el microscopio jamás rompe al llamador */ }
}
